import { z } from "zod";

const envSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_API_BASE_URL: z.string().url(),
  // Optional in every environment. When set (staging/prod), Sentry turns
  // on automatically (see `sentry.ts`); when blank, the crash reporter
  // falls back to `console.error`. Flip to required once a prod Sentry
  // project exists — re-add a `.refine()` gating on VITE_APP_ENV.
  VITE_SENTRY_DSN: z.string().url().optional().or(z.literal("")),
  // Build-time release tag (git sha), injected by CI and forwarded to
  // Sentry as the release. Optional — local/dev builds leave it blank.
  VITE_APP_RELEASE: z.string().optional(),
  VITE_APP_ENV: z.enum(["development", "staging", "production"]).default("development"),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("Invalid environment configuration:", parsed.error.flatten().fieldErrors);
  throw new Error("Missing or invalid environment variables. See .env.example.");
}

export const env = parsed.data;
